import { CClient } from '@common/utils'
import Partner, { PartnerProps } from '@components/partner'
import ProfilePage from '@components/profile'
import ShortLink, { ClassroomDetailsType } from '@components/short-link'
import { PARTNERS } from '@lib/constants/partner'
import { ProfileDetailsType } from '@lib/types/profile'
import { getServerSideRedirectResult } from '@lib/utils/common'
import { GetServerSideProps } from 'next'

type Props = {
  page: 'short-link' | 'profile' | 'partner-lp'
  partner?: PartnerProps
  classroomDetails?: ClassroomDetailsType
  profileDetails?: ProfileDetailsType
}

/** This path is used for:
 *    - Partner page
 *    - Classroom short link page
 *    - Profile page
 */
const Index = ({ page, classroomDetails, profileDetails, partner }: Props) => {
  if (page === 'short-link')
    return <ShortLink classroomDetails={classroomDetails} />
  else if (page === 'profile')
    return <ProfilePage profileDetails={profileDetails} />
  else if (page === 'partner-lp') return <Partner {...partner} />
  else return null
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug = ctx.params?.slug as string

  const partner = PARTNERS.find((partner) => partner.slug === slug)

  if (partner)
    return {
      props: {
        page: 'partner-lp',
        partner,
      },
    }

  // Fetch short link page details
  const response = await CClient(`/api/v1/classroom/${slug}/`)

  if (response.ok) {
    const classroomDetails: ClassroomDetailsType = await response.json()

    return { props: { classroomDetails, page: 'short-link' } }
  }

  if (response.status === 404) {
    // Short link details not found, check for profile details
    // URL pattern for profile: /@<username>
    if (slug?.charAt(0) !== '@') return { props: {}, notFound: true }

    const profileResponse = await CClient(`/api/v1/profiles/${slug.slice(1)}/`)

    if (profileResponse.status === 404) return { props: {}, notFound: true }
    if (!profileResponse.ok)
      return getServerSideRedirectResult(ctx, `/${profileResponse.status}`)

    const data: ProfileDetailsType = await profileResponse.json()

    return {
      props: {
        profileDetails: data,
        page: 'profile',
      },
    }
  }
  return getServerSideRedirectResult(ctx, `/${response.status}`)
}

export default Index
